import upperFirst from 'lodash/upperFirst';

import { LimitConfigurationInput } from '@occc/graphql';

import { LimitBaseInput, LimitScope, LimitTimePeriod, LimitType } from './types';

export const getGlobalOrMembershipLimitConfiguration = (
  values: LimitBaseInput,
  limitType: LimitType,
  limitScope: LimitScope,
) => {
  const isInTimeLimit = values.timePeriod !== LimitTimePeriod.Total;
  const nameTimePostfix = isInTimeLimit ? 'InTime' : '';
  const limitName = `${limitScope}${upperFirst(
    limitType,
  )}${nameTimePostfix}` as keyof LimitConfigurationInput;

  return {
    [limitName]: {
      limit: values.limit,
      timePeriod: isInTimeLimit ? values.timePeriod : undefined,
    },
  };
};
